/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type PropsWithChildren } from 'react';

import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { useAppContext } from '../../../app-context';

const styles = css({
	display: 'flex',
	boxSizing: 'border-box',
	flexDirection: 'column',
	overflowY: 'auto',
	overflowX: 'hidden',
	paddingBlock: token('space.250'),
	paddingInline: token('space.050'),
	justifyContent: 'start',
});

export type AppFilterSidebarContainerProps = {
	ariaLabel: string;
	testId?: string;
};

// TODO: QS-8171 sidebar height calculation should be improved to not re-define nav/header heights
const NAV3_HEIGHT = 56;
const NAV4_HEIGHT = 48;
const HEADER_FILTER_HEIGHT_WITH_NAV3 = 140;
const HEADER_FILTER_HEIGHT_WITH_NAV4 = 76;

export const SidebarContainer: ({
	ariaLabel,
	testId,
	children,
}: PropsWithChildren<AppFilterSidebarContainerProps>) => JSX.Element = ({
	ariaLabel,
	testId,
	children,
}: PropsWithChildren<AppFilterSidebarContainerProps>) => {
	const { isNav4Enabled } = useAppContext();
	const navHeight = isNav4Enabled ? NAV4_HEIGHT : NAV3_HEIGHT;
	const headerFilterHeight = isNav4Enabled
		? HEADER_FILTER_HEIGHT_WITH_NAV4
		: HEADER_FILTER_HEIGHT_WITH_NAV3;
	return (
		<div
			role="group"
			aria-label={ariaLabel}
			data-testid={testId}
			css={styles}
			// Can be moved to CSS when nav4 is GA
			style={{ height: `calc(100vh - ${navHeight}px - ${headerFilterHeight}px)` }}
		>
			{children}
		</div>
	);
};
